import React from 'react';
import SimpleProductPage from './PriceComparison/SimpleProductPage';
import { 
  findProductById, 
 
  getProductImage, 
  getProductCsvLookupId 
} from '../utils/productHelpers';

const SimplePanoptixPS22 = () => {
  console.log('🎯 SimplePanoptixPS22 component loading');
  
  const product = findProductById("panoptix-ps22");
  
  if (!product) {
    console.error('Product not found:', "panoptix-ps22");
    return <div>Product not found</div>;
  }
  
  return (
    <SimpleProductPage 
      specificProductId="panoptix-ps22"
      productName={product.name}
      productImage={getProductImage(product)}
      csvLookupId={getProductCsvLookupId(product)}
    />
  );
};

export default SimplePanoptixPS22; 